<template>
  <router-link
    class="settings-item"
    :to="path"
  >
    <Icon
      name="duotone-settings"
      class="settings-item__icon"
    />
    <div class="settings-item__text">
      {{ label }}
    </div>
  </router-link>
</template>

<script setup lang="ts">
import Icon from '@/uiKit/Icon/Icon.vue'
import { resolveSettingsRoutePath } from '@/utils/router'
import { computed } from 'vue'

import { useAuth } from '@/modules/Auth/useAuth'
import { useRoute, useRouter } from 'vue-router'

const { isAuthorized } = useAuth()
const router = useRouter()
const route = useRoute()

const path = computed(() => {
  const settingsTab = isAuthorized('manage_customer') ? 'plans' : 'profile'
  return resolveSettingsRoutePath(router, route, settingsTab)
})

const label = computed(() => (isAuthorized('manage_customer') ? 'Settings & Billing' : 'Settings'))
</script>

<style lang="scss" scoped>
.settings-item {
  @include row;
  align-items: center;
  padding: 6px 6px;
  border-radius: 6px;

  &:hover {
    background-color: var(--color-background-transparent-hovered);
  }

  &__icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    color: var(--color-icon-subtle);
  }

  &__text {
    @include typography(md-1, headlines);
    @include typographyRegularBody200;
    color: var(--color-text-default);
  }
}
</style>
